export const firstColumns = [
  { prop: "tagName1", label: "一级标签" },
  { prop: "operator", label: "编辑人" },
  { prop: "modifyTime", label: "编辑时间" },
  { prop: "operate", label: "操作" },
];
export const secondColumns = [
  { prop: "tagName2", label: "二级标签" },
  { prop: "tagName1", label: "一级标签" },
  { prop: "operator", label: "编辑人" },
  { prop: "modifyTime", label: "编辑时间" },
  { prop: "operate", label: "操作" },
];
export const thirdColumns = [
  { prop: "tagName3", label: "三级标签" },
  { prop: "tagName2", label: "二级标签" },
  { prop: "tagName1", label: "一级标签" },
  { prop: "operator", label: "编辑人" },
  { prop: "modifyTime", label: "编辑时间" },
  { prop: "operate", label: "操作" },
];
